<app-header/>

<!-- Кошик малюємо один раз - коли прийшли і дані, і активна організація (від неї залежить валюта, картка #388) -->
<div class="empty-basket row" *ngIf="isOrganizationKnown && basketGoods && !basketGoods.goods_list.length">
  <div class="column text-center">
    <h3>КОШИК ТОВАРІВ ПОРОЖНІЙ.</h3>
    <p>
      <a routerLink="/account" class="button">Продовжити покупки</a>
    </p>
    <p>
      <a (click)="openUploadOrderModal()" class="alert-link">Завантажити замовлення з файлу</a>
    </p>
  </div>
</div>

<div *ngIf="isOrganizationKnown && basketGoods && basketGoods.goods_list.length" class="row basket-header">
  <div class="column shrink desktop-version">
    <h2>Кошик товарів</h2>
  </div>
  <div class="column-padding desktop-version"></div>
  <div class="column shrink text-center desktop-version">
    <a (click)="getOrders()" class="alert-link">Завантажити кошик в XLS</a>
  </div>
  <div class="column shrink text-center btn_wrap_line">
    <a (click)="openUploadOrderModal()" class="alert-link">Замовлення файлом</a>
  </div>
  <div class="column shrink text-center btn_wrap_line">
    <a (click)="clearBasket()" class="alert-red">Очистити кошик</a>
  </div>
  <div class="column shrink text-center btn_wrap_line">
    <a routerLink="/account" class="alert-link">Продовжити покупки</a>
  </div>

  <div class="column shrink text-center btn_wrap_line desktop-version" *ngIf="delivery">
    <img *ngIf="delivery == 1 || delivery > 30" src="/assets/images/icons/delicons/1.png" width="478" height="279">
    <img *ngIf="delivery == 2" src="/assets/images/icons/delicons/2.png" width="312" height="227">
    <img *ngIf="delivery == 3 || delivery == 11" src="/assets/images/icons/delicons/3.png" width="200" height="83">
    <img *ngIf="delivery == 5" src="/assets/images/icons/delicons/5.png" width="131" height="76">
    <img *ngIf="delivery == 7" src="/assets/images/icons/delicons/9.png" width="312" height="227">
    <img *ngIf="delivery == 8" src="/assets/images/icons/delicons/7.png" width="502" height="495">
    <img *ngIf="delivery == 9" src="/assets/images/icons/delicons/8.png" width="58" height="43">
    <img *ngIf="delivery == 10" src="/assets/images/icons/delicons/10.png" width="826" height="471">
  </div>

  <div class="column shrink desktop-version">
    <div class="btn_dropdown_delivery">
      <button class="button change_delivery_method" *ngIf="deliveryCurrent">
        Вибір доставки, складу
        <small>
          {{ deliveryCurrent.name }}
          <ng-container *ngIf="deliveryCurrent.id !== 2 && deliveryCurrent.id !== 7">
            , {{ wars[1].name }}
          </ng-container>
        </small>
      </button>
      <div class="list_dels">
        <ul class="fake_select">
          <li *ngFor="let del of deliveryList" (click)="setDelivery(del.id)">
            <b>{{ del.name }}</b>
            <p [innerHTML]="del.comment"></p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isOrganizationKnown && basketGoods && basketGoods.goods_list.length" class="basket-header navs-btns">
  <div class="column shrink mobile-version">
    <div class="btn_dropdown_delivery">
      <button class="button change_delivery_method" *ngIf="deliveryCurrent" (click)="showDelivery()">
        Вибір доставки, складу
        <small>
          {{ deliveryCurrent.name }}
          <ng-container *ngIf="deliveryCurrent.id != 2 && deliveryCurrent.id != 7">
            , {{ wars[1].name }}
          </ng-container>
        </small>
      </button>
      <div class="list_dels" [class.hide]="!showMobileDelivery" [class.show]="showMobileDelivery">
        <ul class="fake_select">
          <li *ngFor="let del of deliveryList" (click)="setDelivery(del.id)">
            <b>{{ del.name }}</b>
            <p [innerHTML]="del.comment"></p>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div *ngIf="delivery" class="column shrink text-center btn_wrap_line mobile-version">
    <img *ngIf="delivery == 1 || delivery > 30" src="/assets/images/icons/delicons/1.png" width="478" height="279">
    <img *ngIf="delivery == 2" src="/assets/images/icons/delicons/2.png" width="312" height="227">
    <img *ngIf="delivery == 3 || delivery == 11" src="/assets/images/icons/delicons/3.png" width="200" height="83">
    <img *ngIf="delivery == 5" src="/assets/images/icons/delicons/5.png" width="131" height="76">
    <img *ngIf="delivery == 7" src="/assets/images/icons/delicons/9.png" width="312" height="227">
    <img *ngIf="delivery == 8" src="/assets/images/icons/delicons/7.png" width="502" height="495">
    <img *ngIf="delivery == 9" src="/assets/images/icons/delicons/8.png" width="58" height="43">
    <img *ngIf="delivery == 10" src="/assets/images/icons/delicons/10.png" width="826" height="471">
  </div>
</div>

<div class="row attention mobile-version" *ngIf="isOrganizationKnown && basketGoods && basketGoods.unbottled_packs.length">
  <div class="column">
    <p class="red">Ціна розливної олії вказана без урахування тари</p>
  </div>
</div>

<div *ngIf="isOrganizationKnown && basketGoods && basketGoods.goods_list.length" class="basket-page">
  <div class="row basket-page-row-table">
    <div class="column">
      <table class="basket-table">
        <thead>
        <tr>
          <th class="basket-table-checkbox desktop-version">
            <input
              type="checkbox"
              class="check_all"
              [checked]="turned_on"
              (change)="toggleAllBasketRows()"
            >
          </th>
          <th class="remove-good desktop-version"></th>
          <th class="goods-name-title-mobile">Найменування</th>
          <th>Артикул</th>
          <th>Об'єм</th>
          <th>Ціна</th>
          <th>Склад</th>
          <th>Умова</th>
          <th>Кіл-ть</th>
          <th>Сума</th>
          <th class="remove-good mobile-version"></th>
          <th class="basket-table-checkbox mobile-version">
            <input
              type="checkbox"
              class="check_all"
              [checked]="turned_on"
              (change)="toggleAllBasketRows()"
            >
          </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let good of basketGoods.goods_list; let i = index" [class.assistant-highlight]="highlight.has(good.mt_source_id)">
          <td class="desktop-version">
            <input
              type="checkbox"
              class="checkbox check_all"
              [checked]="good.turned_on"
              (change)="toggleBasketRow(good)"
            >
          </td>
          <td class="fchild desktop-version">
            <a (click)="deleteFromBasket(good)"></a>
          </td>
          <td class="goods-name-desktop">
            {{ good.name }}
            <ng-container *ngIf="good.unbottled">
              <p *ngIf="!good.factory_packing" class="red desktop-version">Ціна вказана без урахування тари</p>
              <div>
                <input
                  [id]="'fac_pack_' + good.package_id + '_' + good.warehouse"
                  type="checkbox"
                  [(ngModel)]="good.factory_packing"
                  (click)="toggleFactoryPacking(good, $event)"
                >
                <label
                  [for]="'fac_pack_' + good.package_id + '_' + good.warehouse">
                  Отримати товар у заводській упаковці
                </label>
              </div>
            </ng-container>
          </td>

          <td class="goods-name-mobile">
            {{ good.name }}
            <ng-container *ngIf="good.unbottled">
              <p *ngIf="!good.factory_packing" class="red desktop-version">Ціна вказана без урахування тари</p>
              <div (click)="notCopyText($event)">
                <input
                  [id]="'fac_pack_' + good.package_id + '_' + good.warehouse"
                  type="checkbox"
                  [(ngModel)]="good.factory_packing"
                  (click)="toggleFactoryPacking(good, $event)"
                >
                <label
                  [for]="'fac_pack_' + good.package_id + '_' + good.warehouse">
                  Отримати товар у заводській упаковці
                </label>
              </div>
            </ng-container>
          </td>
          <td class="desktop-article">{{ good.first_article }}</td>
          <td class="copy-article-mobile" (click)="articleCopy(good.first_article)">{{ good.first_article }}</td>
          <td>{{ good.litraj }}</td>
          <td>{{ good.priceEUR }} {{ activeOrganization && activeOrganization.type !== 'fiz' ? 'UAH' : 'EUR' }}</td>
          <td>
            {{ good.pod_zakaz ? good.supplier : wars[good.warehouse].name }}
            <!-- Подзаказной: бэк разложил количество по складам поставщика (m_basket → wh_split) -->
            <div class="wh-split" *ngIf="good.wh_split && good.wh_split.length > 1">
              з {{ good.wh_split.length }} складів:
              <span *ngFor="let wh of good.wh_split; let last = last">{{ wh.name }} {{ wh.count }}{{ last ? '' : ', ' }}</span>
            </div>
            <div class="wh-split" *ngIf="good.wh_split && good.wh_split.length === 1">
              {{ good.wh_split[0].name }}
            </div>
          </td>
          <td>
            <span class="text-styles">{{ good.expire_text }}</span>
          </td>
          <td class="count-basket">
            <div class="buttons_count_to_basket">
              <span class="minus" (click)="minusCount(good)">-</span>
              <span class="number contenteditable"
                    (input)="goodInput(good, i)"
                    #inputCount
                    appContenteditable
                    [onlyNumber]="true"
                    [(ngModel)]="good.count"></span>
              <span class="plus" (click)="plusCount(good)">+</span>
            </div>
          </td>
          <td>{{ (good.summa).toFixed(2) }} {{ activeOrganization && activeOrganization.type !== 'fiz' ? 'UAH' : 'EUR' }}</td>
          <td class="fchild remove-good mobile-version">
            <a (click)="deleteFromBasket(good)"></a>
          </td>
          <td class="basket-table-checkbox mobile-version">
            <input
              type="checkbox"
              class="checkbox check_all"
              [(ngModel)]="good.turned_on"
              (change)="toggleBasketRow(good)"
            >
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

  <h4 *ngIf="basketGoods.unbottled" class="unbottled-title">Тара:</h4>

  <div *ngIf="basketGoods.unbottled" class="row">
    <div class="shrink unbottled">
      <table class="unbottled-table">
        <thead>
        <tr>
          <th class="goods-unbottled-name-mobile">Найменування</th>
          <th class="desktop-version">Артикул</th>
          <th>Ціна</th>
          <th>Кіл-ть</th>
          <th>Сума</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let unbottled of basketGoods.unbottled_packs; let i = index">
          <td class="goods-unbottled-name-mobile">{{ unbottled.good_name }} {{ unbottled.name }}</td>
          <td class="desktop-version">{{ unbottled.article }}</td>
          <td>{{ unbottled.tara_priceEUR }} EUR</td>
          <td class="countbasket">
            <div class="buttons_count_to_basket">
              <span class="minus" (click)="countMinusTara(unbottled)">-</span>
              <span
                class="number"
                (input)="countGoodTara(unbottled, i)"
                #inputTaraCount
                appContenteditable
                [onlyNumber]="true"
                [(ngModel)]="unbottled.count_tara"
              ></span>
              <span class="plus" (click)="countPlusTara(unbottled)">+</span>
            </div>
          </td>
          <td class="summa_unbottled">{{ unbottled.summa }} EUR</td>
        </tr>
        </tbody>
      </table>
      <div class="row desktop-version">
        <div class="column shrink">
          <b class="footer-styles" *ngIf="basketGoods.unbottled_covered_liters > 0">Тара
            для {{ basketGoods.unbottled_covered_liters }}
            літрів</b>
        </div>
        <div class="column shrink">
          <b *ngIf="basketGoods.tara_summa > 0">Вартість тари {{ (basketGoods.tara_summa).toFixed(2) }} EUR</b>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="basketGoods.unbottled && basketGoods.tara_summa > 0" class="column shrink price-tara mobile-version">
    <b>Вартість тари {{ (basketGoods.tara_summa).toFixed(2) }} EUR</b>
  </div>
  <div *ngIf="basketGoods.unbottled && basketGoods.unbottled_covered_liters > 0"
       class="column shrink amount-tara mobile-version">
    <b class="footer-styles">Тара
      для {{ basketGoods.unbottled_covered_liters }}
      літрів</b>
  </div>

  <div class="row desktop-version">
    <div *ngIf="basketGoods.liters" class="column shrink">
      <h3>Кількість літрів: <span class="alert">{{ basketGoods.liters }}</span></h3>
    </div>
    <div class="column shrink">
      <h3>Разом до сплати:
        <ng-container *ngIf="activeOrganization && activeOrganization.type !== 'fiz'">
          <span class="alert">{{ sum_Convert_EUR_In_UAH }} UAH</span>
        </ng-container>
        <ng-container *ngIf="!activeOrganization || activeOrganization.type === 'fiz'">
          <span>{{ basketGoods.summa }} EUR</span>
          <span class="alert">({{ sum_Convert_EUR_In_UAH }} UAH)</span>
        </ng-container>
      </h3>
    </div>
  </div>

  <div *ngIf="basketGoods.liters" class="column shrink amount-tara mobile-version">
    <h3>Кількість літрів: <span class="alert">{{ basketGoods.liters }}</span></h3>
  </div>
  <div class="column shrink together-before-payment mobile-version">
    <h3>До сплати:
      <ng-container *ngIf="activeOrganization && activeOrganization.type !== 'fiz'">
        <span class="alert">{{ sum_Convert_EUR_In_UAH }} UAH</span>
      </ng-container>
      <ng-container *ngIf="!activeOrganization || activeOrganization.type === 'fiz'">
        <span>{{ basketGoods.summa }} EUR</span>
        <span class="alert">({{ sum_Convert_EUR_In_UAH }} UAH)</span>
      </ng-container>
    </h3>
  </div>

  <!-- Скільки місць займе замовлення (картка #218). Ціни тут ще немає: місто одержувача
       обирають на етапі оформлення, без нього НП тариф не порахує. -->
  <div class="row">
    <div class="column shrink">
      <app-delivery-estimate
        [deliveryId]="delivery"
        [refreshToken]="estimateToken"
        [background]="true"
      />
    </div>
  </div>

  <div
    *ngIf="(delivery == 3 || delivery == 8) && basketGoods.liters && basketGoods.liters > 0 && basketGoods.liters < 10"
    class="row"
  >
    <div class="column"></div>
    <div class="column shrink">
      <span class="packaging-cost-styles" *ngIf="basketGoods.liters < 5">
        Увага! Буде додано вартість упаковки 20 грн
      </span>
      <span class="packaging-cost-styles" *ngIf="basketGoods.liters >= 5">
        Увага! Буде додано вартість упаковки 25 грн
      </span>
    </div>
  </div>

  <div class="row items-center">
    <div class="column shrink">
      <b *ngIf="deliveryGoodDate" class="prompt">
        {{ deliveryGoodDate }}
      </b>
      <a *ngIf="!isButtonsOrdersShow"
         class="button button_next_ordering"
         (click)="continueOrdering()"
         [class.inactive-button]="basketGoods.unbottled && basketGoods.unbottled_liters > basketGoods.unbottled_covered_liters"
      >Продовжити оформлення</a>
    </div>
  </div>

  <div class="row">
    <div class=" column shrink">
      <div class="basket-notification-message">
        <span>
          Не зволікай з замовленням - додавання товару в кошик <br> не означає бронювання
        </span>
      </div>
    </div>
  </div>

  <div *ngIf="isButtonsOrdersShow" class="hidden-buttons buttons-separate-orders-show">
    <div class="row form-data-center">
      <div class="column shrink button-next-ordering-styles">
        <a class="button button_next_ordering" (click)="setupSessionSeparateOrders(0)">Відвантажити одним
          замовленням</a>
        <small class="text-center but_describe">Накладна буде відвантажена по прибуттю замовного товару</small>
      </div>
      <div class="column shrink button-next-ordering-styles">
        <a class="button button_next_ordering" (click)="setupSessionSeparateOrders(1)">Відвантажити різними
          замовленнями</a>
        <small class="text-center but_describe">Накладна буде відвантажена не чекаючи замовний позиції</small>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isCopyTextShow" class="success-mess-copy">Текст скопійовано в буфер обміну</div>

<div *ngIf="isOrganizationKnown && basketGoods && !basketGoods.goods_list.length" class="footer mobile-version">
  <footer>
    <small>© 2010-{{ currentYear }} Maslotochka. Всі права захищені.</small>
  </footer>
</div>

<div *ngIf="isOrganizationKnown && basketGoods && basketGoods.goods_list.length" class="footer-goods mobile-version">
  <footer>
    <small>© 2010-{{ currentYear }} Maslotochka. Всі права захищені.</small>
  </footer>
</div>

<app-modal-no-selected-goods></app-modal-no-selected-goods>
<app-modal-upload-order (importedEvent)="onOrderImported()"></app-modal-upload-order>
